import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { isFileProcessing } from '../helpers/Files';

const ProcessingIcon = ({
  file,
  job,
  icon,
  effect,
  tooltipText,
}) => {
  const intl = useIntl();

  if (!isFileProcessing(file, job)) {
    return null;
  }

  return (
    <>
      <span id="processing-icon" className="processing-icon">
        <i className={`fa-regular ${icon} ${effect}`} />
      </span>
      <UncontrolledTooltip fade={false} target="processing-icon">
        {tooltipText || intl.formatMessage({ defaultMessage: 'Processing...' })}
      </UncontrolledTooltip>
    </>
  );
};

ProcessingIcon.propTypes = {
  file: PropTypes.object.isRequired,
  job: PropTypes.string.isRequired,
  icon: PropTypes.string,
  effect: PropTypes.string,
  tooltipText: PropTypes.string,
};

ProcessingIcon.defaultProps = {
  icon: 'fa-sparkles',
  effect: 'fa-fade',
  tooltipText: null,
};

export default ProcessingIcon;
